import React from 'react';
import { classNames } from './classNames';

export type FormProps = React.FormHTMLAttributes<HTMLFormElement>;

const Form = React.forwardRef<HTMLFormElement, FormProps>(({
  className,
  children,
  ...props
}, ref) => (
  <form ref={ref} className={classNames(className)} {...props}>
    {children}
  </form>
));

Form.displayName = 'Form';

export default Form;
